import { FormattedMessage } from 'react-intl';
import { Tile } from 'components/Layout/PageContainer';
import { TbIcon } from 'components/Figma';

interface BlurbTexts {
  tickLineIds: string[];
  footerId?: string;
}
interface TeaserTileProps extends BlurbTexts {
  imgSrc?: string;
}

export function TeaserTile({ tickLineIds, footerId = '', imgSrc = '' }: TeaserTileProps) {
  return (
    <Tile className="flex flex-row items-start gap-10 justify-start">
      {imgSrc && <img className="block col-span-6 w-48" src={imgSrc} alt="Pro Teaser" />}
      <div>
        <div className="w-[160px] mb-2">
          <img src="/tradebyte/tb360/teaser-tb360pro-logo.svg" alt="tb360 Pro" />
        </div>
        <div className="whitespace-pre text-2xl font-bold mb-6">
          <FormattedMessage id="pro-teaser.common.header" />
        </div>
      </div>
      <div>
        {tickLineIds.map(lineId => (
          <div className="font-bold leading-8 flex items-top text-lg" key={lineId}>
            <TbIcon name="Checkmark" className="mt-2" />
            <p>
              <FormattedMessage id={lineId} />
            </p>
          </div>
        ))}
        {footerId && (
          <div className="leading-8">
            <FormattedMessage id={footerId} />
          </div>
        )}
      </div>
    </Tile>
  );
}
